<template>
<div :class="hiddenElement()">
    <field
      v-if="groupType == 'field' && name != 'company' "
      :errors="errors"
      model="project_lead"
      v-can="'project_leads.update'"
      :name="name"
      :id='name'
      :type="elem_type"
      :required="element.required"
      :params="element.params"
      :class="elem_class"
      :collection="element.allowed_values"
      :defaultValue="element.default_value"
      v-model="item[name]"
      :placeholder="placeholder"
      :label="label"
      :fromLeadMask="true"
      :enrich_tags="element.enrich_tags"
      v-on:change="change"
      v-on:populate-fields="populateFields"
    />

    <auto-complete
      v-else-if="groupType == 'field' && name == 'company'"
      model="project_lead"
      v-can="'project_leads.update'"
      :name="name"
      class="autofill"
      @populate-fields="populateFields"
      :item="item"
      :label="label"
      :fromLeadMask="true"
      :type="elem_type"
      @change="updateName"
      :required="element.required"
      :params="element.params"
      :class="elem_class"
      :collection="items"
      v-model="item[name]"
      :init="item[name]"
      :placeholder="placeholder"
    />

    <field
      v-else-if="groupType == 'readonly'"
      :errors="errors"
      model="project_lead"
      v-can="'project_leads.update'"
      :readonly="true"
      :name="name"
      :id='name'
      type="text"
      :required="element.required"
      :params="element.params"
      :class="elem_class"
      :collection="element.allowed_values"
      :defaultValue="element.default_value"
      v-model="item[name]"
      :placeholder="placeholder"
      :label="label"
      :fromLeadMask="true"
      v-on:change="change"
      @populate-fields="populateFields"
    />

    <quantity-selection
      v-else-if="groupType == 'quantity_selection'"
      :errors="errors"
      model="project_lead"
      v-can="'project_leads.update'"
      :name="name"
      :id='name'
      :type="elem_type"
      :required="element.required"
      :params="element.params"
      :class="elem_class"
      :collection="element.allowed_values"
      :defaultValue="element.default_value"
      v-on:change="change"
      @populate-fields="populateFields"
      v-model="item[name]"
      :label="label"
    />

    <country-select
      v-else-if="groupType == 'country_select'"
      :errors="errors"
      :name="name"
      :params="element.params"
      :id='name'
      @change="bus(data)"
      model="project_lead"
      :label="label"
      :fromLeadMask="true"
      :required="required"
      :language="language"
      @populate-fields="populateFields"
      v-model="item[name]"
    />

    <tag-list
      v-else-if="groupType == 'tag_list'"
      :errors="errors"
      :name="name"
      model="project_lead"
      :id='name'
      :required="required"
      :label="label"
      :fromLeadMask="true"
      v-model="item[name]"
      @populate-fields="populateFields"
    />

    <free-drawing
      v-else-if="groupType == 'free_drawing'"
      :errors="errors"
      :name="name"
      :id='name'
      model="project_lead"
      :required="required"
      :label="label"
      v-model="item[name]"
    />

    <crawled-infos
      v-else-if="groupType == 'crawled_info'"
      :type="elem_type"
      :params="element.params"
      :class="elem_class"
      :item="item"
    />

    <div class="field" v-else-if="groupType == 'date'">
      <label :for="name">{{label}}</label>
      <datepicker
        :item="item"
        :name="name"
        :id='name'
        v-model="item[name]"
        :class="elem_class"
        @populate-fields="populateFields"
        :required="required"
        :errors="errors"
        :label="label"
        :clear-button="true"
        :language="getDatePickerLanguage()"
      />
    </div>

    <div v-else-if="groupType == 'title'">
      <h3>{{element.content}}</h3>
    </div>

    <div v-else-if="groupType == 'paragraph'">
      <p v-html="element.content"></p>
    </div>

    <div class="element" :class="elem_class" v-else-if="groupType == 'container'">
      <lead-mask-element
        v-for="element in element.children"
        :key="element.name"
        :type="element.element_type"
        :element="element"
        @populate-fields="populateFields"
        :name="element.name"
        :label="element.label"
        :errors="errors"
        :language="language"
        :item="item"
      />
    </div>
</div>
</template>
<script>
window.EventBus = new Vue();
import Vue from 'vue'
import LeadMaskElement from '@/components/pages/project/leads/LeadMaskElement'
import Field from '@/components/helpers/DataInput/Field'
import CountrySelect from '@/components/helpers/DataInput/CountrySelect'
import TagList from '@/components/helpers/DataInput/TagList'
import QuantitySelection from '@/components/helpers/DataInput/QuantitySelection'
import CrawledInfos from '@/components/helpers/DataDisplay/CrawledInfos'
import Datepicker from 'vuejs-datepicker'
import FreeDrawing from '@/components/helpers/DataInput/FreeDrawing'
import AutoComplete from '@/components/helpers/DataDisplay/AutoComplete'

export default {
  components: { LeadMaskElement, AutoComplete, FreeDrawing, QuantitySelection, CountrySelect, TagList, Field, CrawledInfos, Datepicker },
  name: "lead-mask-element",
  props: {
      name: String,
      language: String,
      item: Object,
      type: String,
      element: Object,
      errors: Array,
      params: String,
      value: String
  },
  data(){
    return {
      elem_class: "",
      elem_type: "",
      newValue: "",
      placeholder: "",
      label: "",
      search:'',
      results: [],
      isOpen: true,
      required: false,
      items: []
    }
  },
  methods: {
    findValue(){
      return eval('this.item.' + name)
    },
    populateFields(companyFields){
     this.$emit('populate-fields', companyFields)
    },
    change(object, label, name) {
      EventBus.$emit('change', object, label, name)
    },
    updateName(result){
      this.$set(this.item, 'company', result.name);
    },
    hiddenElement() {
      if (this.element.hidden) {
        return "hidden"
      }
    }
  },
  mounted(){
    if(this.element.class){
      this.elem_class = this.element.class
    }
    this.elem_type = this.type
    this.newValue = this.value

    if(this.element.required){
      this.required = this.element.required
    }
    if(this.element.placeholder){
      this.placeholder = this.element.placeholder
    }
    if(this.element.label){
      this.label = this.element.label
    }

    if(this.groupType == "container"){
      switch(this.type) {
        case "container_tab":
          this.elem_class += "tab"
          break;
        case "container_grid":
          this.elem_class += " grid"
          break;
        case "container_top":
          this.elem_class += " form-part"
          break;
        case "container_bottom":
          this.elem_class += " bottom-zone"
          break;
        case "container":
          this.elem_class += " container"
          break;
      }
    }else{
      if((this.type == "checkbox_custom" || this.type == "radio_custom") || this.element.show_as_buttons){
        this.elem_type = this.type.replace('_custom','')
        this.elem_class += " is-buttonned"
      }
      if(this.elem_type == "checkbox"){
        this.newValue = new Array()
      }
      if(this.elem_type == "date"){
        this.newValue = new Date()
        this.elem_class += " input--datepicker"
      }
    }
    EventBus.$on('input',this.handleAutoComplete)

    // This is to stop the browsers native autocomplete overlaying our own autocomplete component
    this.$nextTick(() => {
      let isFirefox = typeof InstallTrigger !== 'undefined';

      // check for existance
      if (document.querySelector("#name")) {
        if(!isFirefox){
          document.querySelector("#name").setAttribute('autocomplete', 'usedforstoppingAC');
        }
        else { document.querySelector("#name").setAttribute('autocomplete', 'off');
        }
      }
    })

  },
  computed: {
    groupType(){
      if(this.type.includes('container')){
        return "container"
      }else if(this.type == "country_select"){
        return "country_select"
      }else if(this.type == "quantity_selection"){
        return "quantity_selection"
      }else if(this.type == "tag_list"){
        return "tag_list"
      }else if(this.type == "crawled_info"){
        return "crawled_info"
      }else if(this.type == "readonly"){
        return "readonly"
      }else if(this.type == 'title'){
        return "title"
      }else if(this.type == 'drawing'){
        return "free_drawing"
      }else if(this.type == 'paragraph'){
        return "paragraph"
      }else if(this.type == 'date'){
        return "date"
      }else{
        return "field"
      }
    },
    isBlank(){
      return this.value == ''
    },
    containerClass(){
      if(this.groupType == "container"){
        switch(this.type) {
          case "container_tab":
            return this.class + "tab"
            break;
          case "container_grid":
            return this.class + " grid"
            break;
          case "container_top":
            return this.class + " form-part"
            break;
          case "container_bottom":
            return this.class + " bottom-zone"
            break;
        }
      }else{
        return ""
      }
    }
  },
  watch: {
    value (val) {
      if (val !== this.newValue) {
        this.newValue = val
      }
    },
    newValue (val) {
      this.$emit('input', val)
    },
  }
}
</script>
<style lang="sass" scoped>
.grid.has-gutter > * + *, .grid--reverse.has-gutter > * + *
  margin-left: 0
.container
  margin: 0
  padding: 0
.autofill
  margin-bottom: 0
.input--datepicker
  width: 33%
.hidden
  display: none
</style>
</style>



// WEBPACK FOOTER //
// LeadMaskElement.vue?58f61633